const REQUEST_HOST_ENVIRONMENT_INFO_SUCCESS =
  'REQUEST_HOST_ENVIRONMENT_INFO_SUCCESS';
const REQUEST_HOST_ENVIRONMENT_INFO_ERROR =
  'REQUEST_HOST_ENVIRONMENT_INFO_ERROR';
const ON_SECURE_STORAGE_READY_SUCCESS = 'ON_SECURE_STORAGE_READY_SUCCESS';
const ON_SECURE_STORAGE_READY_FAILURE = 'ON_SECURE_STORAGE_READY_FAILURE';

export {
  REQUEST_HOST_ENVIRONMENT_INFO_SUCCESS,
  REQUEST_HOST_ENVIRONMENT_INFO_ERROR,
  ON_SECURE_STORAGE_READY_SUCCESS,
  ON_SECURE_STORAGE_READY_FAILURE,
};
